(function($) {

    var $document = $(document),
    $window = $(window),
    $scrollable = $('html, body');

    var components = [];

	$(document).ready(function () {

		let homeSlider = $("#home-slider");
		if (homeSlider) {
			homeSlider.carousel({
				pause: true,
				interval: false
			})
		}

		let menuItem = $(".sub-menu");
		if (menuItem.length) {
			$(document).keyup(function (e) {
				if (e.keyCode == 27) {
					menuItem.css("display", "none");
				}
			});
		}

        for (var i = 0; i < components.length; i++) {
            components[i]();
        }

        $window.trigger('debouncedresize').on('load', function() {
            $window.trigger('debouncedresize');
        });

        $(".addtocart").click(function (e) {

            var elem = $(this);
            $(elem).prop("disabled", true);

            e.preventDefault();

            // Add item to cart
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: {
                    quantity: 1,
                    id: elem.data('variant')
                },
                success: Shopify.onSuccess(elem),
                error: Shopify.onError
            });

        });
    });

    Shopify.onSuccess = function (elem) {

        elem.removeAttr("disabled");

        var quantity = 1;

        $("html, body").animate({
            scrollTop: 0
        }, 250, 'swing');

        function animate() {

            $("#cart-animation").show();

            var addtocartWidth = elem.outerWidth() / 2;
            var addtocartHeight = elem.outerHeight() / 2;

            var addtocartLeft = elem.offset().left + addtocartWidth;
            var addtocartTop = elem.offset().top + addtocartHeight;

            var buttonAreaWidth = $("#cart-target").outerWidth();
            var buttonAreaHeight = $("#cart-target").outerHeight();

            var buttonAreaLeft = ($("#cart-target").offset().left + buttonAreaWidth / 2 - $("#cart-animation").outerWidth() / 2) - 4 - 18;
            var buttonAreaTop = ($("#cart-target").offset().top + buttonAreaWidth / 2 - $("#cart-animation").outerHeight() / 2) - 4 - 8;

            var path = {
                start: {
                    x: addtocartLeft,
                    y: addtocartTop,
                    angle: 190.012,
                    length: 0.2
                },
                end: {
                    x: buttonAreaLeft,
                    y: buttonAreaTop,
                    angle: 90.012,
                    length: 0.50
                }
            };

            $('#cart-animation').text(quantity).animate({
                path: new $.path.bezier(path)
            }, 1200, function () {
                $("#cart-animation").fadeOut(500, function () {
                    elem.prop("disabled", false);
                    var cartCount = parseInt($('#cart-count').text()) + quantity;
                    $('.cart-count').text(cartCount);
                    $('.toolbar-cart').addClass('has-items');
                });

                var $upsellModal = undefined;

                if (elem.context.dataset.variant === '13306144194583') {

                    $upsellModal = $('#developer-support-subscription-upsell-modal');

                } else if ($(elem).closest('.card').find('.card-title').text().toLowerCase().indexOf('development kit') !== -1) {

                    $upsellModal = $('#development-kit-upsell-modal');

                }

                if ($upsellModal && $upsellModal.length) $upsellModal.modal('show');
            });
        }

        animate();
    };

    Shopify.onError = function (XMLHttpRequest, textStatus) {
        // Shopify returns a description of the error in XMLHttpRequest.responseText.
        // It is JSON.
        // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
        var data = eval('(' + XMLHttpRequest.responseText + ')');
        if ( !! data.message) {
            alert(data.message + '(' + data.status + '): ' + data.description);
        } else {
            alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
        }

        $('.addtocart').removeAttr("disabled");
    };

    Shopify.fullMessagesFromErrors = function (errors) {
        var fullMessages = [];
        jQuery.each(errors, function (attribute, messages) {
            jQuery.each(messages, function (index, message) {
                fullMessages.push(attribute + ' ' + message);
            });
        });
        return fullMessages;
    };

    function addComponent(selector, callback) {
        if (typeof callback === 'function') {
            components.push(function() {
                var $elements = $(selector);
                if ($elements.length) callback($elements);
            });
        }
    }

    addComponent('#master', function($elem) {

        var heightDiff, $body = $elem.find('.body');

        if ($body.length) {
            $window.on('debouncedresize', function() {

                $body.css('border-bottom', 'none');

                heightDiff = $window.height() - $elem.height();

                if (heightDiff > 0) {
                    $body.css('border-bottom', heightDiff + 'px solid transparent');
                }
            });
        }

        $window.on('load', function() {
            $elem.removeClass('background-color');
        });
    });

    addComponent('#header', function($elem) {

        var $searchForm = $elem.find('.tools .search-form'),
        $searchLabel = $searchForm.find('label[for="search"]'),
        $searchInput = $searchForm.find('#search'),
        $animator = $searchForm.children('.animator'),
        animSpeed = 400;

        $searchForm.on('click', function() {
            $searchLabel.animate({
                opacity: 0
            }, animSpeed / 2, function() {
                $searchInput.focus().animate({
                    opacity: 1
                }, animSpeed / 2);
            });
            $animator.animate({
                width: $searchInput.outerWidth() + 'px'
            }, animSpeed);
        });

        $searchInput.on('blur', function() {
            $searchInput.animate({
                opacity: 0
            }, animSpeed / 2, function() {
                $searchLabel.animate({
                    opacity: 1
                }, animSpeed / 2);
            });
            $animator.animate({
                width: $searchLabel.outerWidth() + 'px'
            }, animSpeed);
		});

        var $mainNav = $elem.find('#main-nav').children('ul');

        // Clone main navigation for mobile menu:

        var $mobileNav = $elem.find('#main-nav').clone();

        $mobileNav.add( $mobileNav.children('ul') ).removeAttr('id class');
        $mobileNav.appendTo('body');

        $mainNav.superfish();
        $mobileNav.mmenu({
            offCanvas: {
                position: 'right'
            },
            extensions: ['border-full', 'pageshadow']
        });

        mobileNavAPI = $mobileNav.data('mmenu');

        var $mobileToggle = $elem.find('button.mobile-toggle'),
        $mobileIcon = $mobileToggle.children('.fa');

        $mobileToggle.on('click', function() {
			mobileNavAPI[ $mobileNav.hasClass('mm-opened') ? 'close' : 'open' ]();
		});

		$mmenuPrev = $(".mm-prev");
		if ($mmenuPrev) {
			$mmenuPrev.attr("aria-label", "Close submenu");
		}

		$mmenuNext = $(".mm-next");
		if ($mmenuNext) {
			$mmenuNext.attr("aria-label", "Open submenu");
		}

        // Replace main navigation's dropdowns with mega menus where appropriate:
        var $megaMenus = $('#mega-menus .mega-menu');

		$megaMenus.each(function () {

            var $thisMenu = $(this),
            $parentItem = $mainNav.find('#menu-item-' + $thisMenu.data('parent-id'));

            var fadeOutTimer;

            function delayFadeOut(delay) {

                if (fadeOutTimer) clearTimeout(fadeOutTimer);

                fadeOutTimer = setTimeout(function() {
                    if ( !$thisMenu.is(':hover') ) $thisMenu.stop().fadeOut('fast');
                }, delay);
                $parentItem.removeClass('hover');
            }

            $parentItem.on('mouseenter', function(e) {

                e.stopPropagation();

                $parentItem.addClass('hover');

                if (fadeOutTimer) clearTimeout(fadeOutTimer);

                setTimeout(function() {
                    $thisMenu.stop().fadeIn(400);
                }, 200);

            }).on('mouseleave', function() {
                delayFadeOut(800);
            }).siblings('.menu-item-has-children').on('hover', function() {
                delayFadeOut(200);
            });

            $thisMenu.on({
                'mouseleave': function() {
                    delayFadeOut(800);
                },
                'mouseenter': function() {
                    if (fadeOutTimer) clearTimeout(fadeOutTimer);
                    $parentItem.addClass('hover');
                }
            });
        });

        // Disable the top menu nav items
        $(".sf-with-ul").on('click', function(evt){ evt.preventDefault(); })
    });

    addComponent('[class*=" template-products"]', function($elem) {

        var bannerHeader = $elem.find('#banner header'),
        bannerImage = $elem.find('#banner aside img');

        if (bannerHeader.length && bannerImage.length) {
            $window.on('debouncedresize', function() {
                if (Modernizr.mq('(min-width: 992px)')) {
                    bannerHeader.css('padding-top', '15px');
                    bannerImage.css('max-height', bannerHeader.height() + 30 + 'px');
                } else {
                    bannerHeader.add(bannerImage).removeAttr('style');
                }
            });
        }

        var sidebar = $elem.find('.sidebar'),
        productTabs = $elem.find('.product-tabs');

        if (sidebar.length && productTabs.length) {
            $window.on('debouncedresize', function() {
                sidebar[ 'insert' + ( Modernizr.mq('(min-width: 992px)') ? 'Before' : 'After' ) ](productTabs);
            });
        }

        if (productTabs.length && productTabs.find(window.location.hash).length) {
            productTabs.find('a[href="' + window.location.hash + '"]').tab('show');
            $scrollable.animate({
                scrollTop: productTabs.offset().top + 30 + 'px'
            }, 0);
        }
    });

    addComponent('.resource-tabs, .product-tabs', function($elem) {

        var opts = $elem.is('.resource-tabs') ? {
            tabsClass: 'hidden-xs hidden-sm hidden-md',
            accordionClass: 'visible-xs visible-sm visible-md'
        } : {
            tabsClass: 'hidden-xs',
            accordionClass: 'visible-xs'
        };

        $elem.children('ul').tabCollapse(opts);

        window.onhashchange = function() {

            var hash = window.location.hash,
            hashLink = $elem.find('a[href="' + hash + '"]'),
            hashTarget = $elem.find(hash);

            if (hashLink.length && hashTarget.length) {
                hashLink.tab('show');
                $scrollable.animate({
                    scrollTop: $elem.offset().top + 'px'
                }, 0);
            }

        };
    });



    })(jQuery);
